import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset window scroll to 0 on every pathname change.
 *
 * SPA navigation (e.g. clicking a legal-doc link in the footer) only
 * changes the URL and swaps the rendered tree — the browser leaves
 * scrollTop where the user clicked from, so a footer click on
 * `/legal/terms` lands on the new page still scrolled to the bottom.
 *
 * Subscribes to `pathname` only: same-page hash navigation (e.g.
 * the `/#features` anchors in the nav and footer) keeps native
 * browser scroll-into-view behavior.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
